// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__xAMJz","load7":"Loader_load7__AtR+0"};